import { level1, level2, level3 } from './level';
export var badges = [{
  id: '1',
  name: 'Badge1',
  imageUrl: 'https://static.influitive.com/influitiveimages/hq/icons/badges/default/hq-badge-education-03.png?1580484661',
  description: 'Quisque quis ultrices massa, ut pharetra sapien. Suspendisse potenti.',
  level: level1
}, {
  id: '2',
  name: 'Badge2',
  imageUrl: 'https://static.influitive.com/influitiveimages/hq/icons/badges/default/hq-badge-replies-03.png?1580484298',
  description: 'Quisque quis ultrices massa, ut pharetra sapien. Suspendisse potenti.',
  level: level1
}, {
  id: '3',
  name: 'Badge3',
  imageUrl: 'https://static.influitive.com/influitiveimages/hq/icons/badges/default/hq-badge-points-03.png?1580484918',
  description: 'Suspendisse potenti. Vestibulum sagittis volutpat velit vel ultrices.',
  level: level1
}, {
  id: '4',
  name: 'Badge4',
  imageUrl: 'https://static.influitive.com/influitiveimages/hq/icons/badges/default/hq-badge-points-03.png?1580484918',
  description: 'Suspendisse potenti. Vestibulum sagittis volutpat velit vel ultrices.',
  level: level1
}, {
  id: '9',
  name: 'Other Badge1',
  imageUrl: 'https://static.influitive.com/influitiveimages/hq/icons/badges/default/hq-badge-points-02.png?1580484810',
  description: 'Quisque quis ultrices massa, ut pharetra sapien.',
  level: null
}, {
  id: '10',
  name: 'Other Badge2',
  imageUrl: 'https://static.influitive.com/influitiveimages/hq/icons/badges/default/hq-badge-replies-01.png?1580484236',
  description: 'Quisque quis ultrices massa, ut pharetra sapien. Suspendisse potenti.',
  level: null
}, {
  id: '11',
  name: 'Other Badge3',
  imageUrl: 'https://static.influitive.com/influitiveimages/hq/icons/badges/default/hq-badge-harassment.png?1580483644',
  description: 'Suspendisse potenti. Vestibulum sagittis volutpat velit vel ultrices.',
  level: null
}];
export var orderedBadges = [{
  id: '111',
  name: 'Apr 1 2021 Badge (lvl 1)',
  imageUrl: 'https://static.influitive.com/influitiveimages/hq/icons/badges/default/hq-badge-points-02.png?1580484810',
  description: 'Quisque quis ultrices massa, ut pharetra sapien. Suspendisse potenti. Vestibulum sagittis volutpat velit vel ultrices.' + 'Etiam tincidunt urna id augue rutrum, tincidunt vulputate velit tincidunt. Integer porta eget lacus id egestas.',
  level: level1
}, {
  id: '333',
  name: '2020 Badge (lvl 3)',
  imageUrl: 'https://static.influitive.com/influitiveimages/hq/icons/badges/default/hq-badge-harassment.png?1580483644',
  description: 'Suspendisse potenti. Vestibulum sagittis volutpat velit vel ultrices.',
  level: level2
}, {
  id: '222',
  name: 'Apr 6 2021 Badge (lvl 2)',
  imageUrl: 'https://static.influitive.com/influitiveimages/hq/icons/badges/default/hq-badge-replies-01.png?1580484236',
  description: 'Quisque quis ultrices massa, ut pharetra sapien. Suspendisse potenti.',
  level: level3
}];